import { useEffect, useState } from "react"

/** Текущее время, обновляемое раз в intervalMs, пока active. Для оценочного прогресса генерации. */
export function useProgressClock(active: boolean, intervalMs = 2000): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!active) return
    setNow(Date.now())
    const id = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(id)
  }, [active, intervalMs])

  return now
}
